import { useUsersApi } from "@/setup/api";

export const fetchUsers = () => useUsersApi().list();

export const fetchCurrentUser = () => useUsersApi().me();

export const updateCurrentUser = (data) => useUsersApi().updateMe({ patchedUserRequest: data });
